var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcUparrow2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4707 8.51672V15.8334C16.4707 17.5001 16.054 18.3334 13.9707 18.3334H6.4707C4.38737 18.3334 3.9707 17.5001 3.9707 15.8334V8.51672",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3877 1.66663H16.0544C17.721 1.66663 18.5544 2.49996 18.5544 4.16663V5.83329C18.5544 7.49996 17.721 8.33329 16.0544 8.33329H4.3877C2.72103 8.33329 1.8877 7.49996 1.8877 5.83329V4.16663C1.8877 2.49996 2.72103 1.66663 4.3877 1.66663Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7041 11.6666H11.7374",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcUparrow2);
export default __webpack_public_path__ + "static/media/Archive_ic_up arrow (2).b3c95995395b8b1ce7b29e34d23d292d.svg";
export { ForwardRef as ReactComponent };